import { useState } from 'react';
import { Checkbox, FormControlLabel, IconButton, TextField, Dialog,
  Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import P from 'prop-types';
import { editPercents } from '../../service/commissionSchema.service';
import PercentsComponents from './PercentsComponents';

export default function CommissionPercentsRangeEdit({ open, setOpen, commissionPercents, mutate, update, channelId }) {
    const [values, setValues] = useState({
        begin: 0,
        end: 0,
        commission: 0,
        description: null,
        loss_percent: 0,
        conversion_percent: 0,
        reduce_percent: 0,
        channelId: null,
    });

    const handleClose = () => {
        setOpen(false);
    };
          
    const submit = async (e) => {
      e?.preventDefault();
    
      const percents = {
        commissionSchema_id: commissionPercents.commissionSchema_id,
        begin: parseFloat(values.begin),
        end: parseFloat(values.end),
        commission: parseFloat(values.commission),
        description: values.description,
        loss_percent: parseFloat(values.loss_percent),
        conversion_percent: parseFloat(values.conversion_percent),
        reduce_percent: parseFloat(values.reduce_percent),
      };

      try {
        await editPercents(percents, commissionPercents.id);
  
        toast.success('Comissão alterada!');
        mutate();
      } catch (error) {
        toast.error('Erro ao alterar a comissão');
      }
  
      update();
      handleClose();
    };

    const entering = () => {
      setValues({
        begin: commissionPercents.begin, 
        end: commissionPercents.end, 
        commission: commissionPercents.commission,
        description: commissionPercents.description || '',
        loss_percent: commissionPercents.loss_percent || 0,
        conversion_percent: commissionPercents.conversion_percent || 0,
        reduce_percent: commissionPercents.reduce_percent || 0,
      });
    }

      
    return (
        <div>
          <Dialog
            TransitionProps={{onEntering: entering}}
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            
            maxWidth="md">
            <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#fc986a' }}>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                Nova Comissão
                <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle >
            <form onSubmit={submit}>
              <DialogContent>

                <PercentsComponents 
                  values={values} 
                  setValues={setValues}
                  channelId={channelId}
                />

              </DialogContent>
              <DialogActions style={{position: 'sticky', bottom: 0, backgroundColor:'white', width:'100%',}}>
                <Button onClick={handleClose} color="primary">
                  Cancelar
                </Button>
                <Button type="submit" color="primary">
                  Salvar
                </Button>
              </DialogActions>
    
            </form>
          </Dialog>
        
        </div>
      );
}
    
CommissionPercentsRangeEdit.propTypes = {
    open: P.bool.isRequired,
    setOpen: P.func.isRequired,
    commissionPercents: P.element.isRequired,
    mutate: P.func.isRequired,
    update: P.func.isRequired,
    channelId: P.number.isRequired,
  };